import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3aafa996"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "createTime" }
const _hoisted_4 = { class: "box mark" }
const _hoisted_5 = { class: "high-light" }
const _hoisted_6 = {
  class: /*#__PURE__*/_normalizeClass('active')
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "space" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rowTips" }, "<" + /*#__PURE__*/_toDisplayString("战斗小组数据") + ">", -1))
const _hoisted_9 = {
  key: 1,
  class: "mark",
  style: {"background-color":"#fff","padding-bottom":"10px"}
}
const _hoisted_10 = { style: {
                fontWeight: 600,
                padding: '10px',
                fontSize: '14px',
              } }
const _hoisted_11 = { class: "groupLeader" }
const _hoisted_12 = {
  key: 0,
  style: {"color":"#f90","font-size":"11px"}
}
const _hoisted_13 = { class: "grap" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#ff7223","padding":"0px 10px 5px","font-size":"14px"} }, "<" + /*#__PURE__*/_toDisplayString("当日数据") + ">", -1))
const _hoisted_15 = {
  border: "1",
  style: {"border-color":"#ccc"}
}
const _hoisted_16 = { style: {"color":"red"} }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"50%"} }, "当日实际激活量", -1))
const _hoisted_18 = { style: {"width":"50%"} }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "当日下单成功量", -1))
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "当日订单总量", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#ff7223","padding":"0px 10px 5px","font-size":"14px"} }, "<" + /*#__PURE__*/_toDisplayString("本月数据") + ">", -1))
const _hoisted_24 = {
  border: "1",
  style: {"border-color":"#ccc"}
}
const _hoisted_25 = { style: {"color":"red"} }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"50%"} }, "本月实际激活量", -1))
const _hoisted_27 = { style: {"width":"50%"} }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "本月下单成功量", -1))
const _hoisted_30 = { key: 1 }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "本月订单总量", -1))

import { ref, watch, onMounted, nextTick, computed } from "vue";
import { useRoute } from "vue-router";
import { formatPercentage, numToMoney } from "@/utils";
import {
  CellGroup,
  Cell,
  Tabs,
  Tab,
  Overlay,
  Loading,
  Empty,
  Collapse,
  CollapseItem,
  Icon,
} from "vant";
import createWatermark from "@/utils/watermark";
import dayjs from "dayjs";
import request from "@/provide/fetch";


export default /*#__PURE__*/_defineComponent({
  __name: 'VerticalMarket331',
  setup(__props) {

const route = useRoute();
const visible = ref(false);
const pageData = ref<any>([]);
const areaList = ref<any>([]);
let time = dayjs(route?.params.time as string).format("YYYY-MM-DD");
const getPageData = async () => {
  const res = await request({
    url: "/api/wx/cs/group-leader-total",
    method: "POST",
    data: {
      startDay: time,
      endDay: time,
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
  });
  if (res.code === 200) {
    pageData.value = res.data;
    visible.value = true;
  } else {
    // showFailToast(res.data);
  }
};
// o7Gwj6b4bHVGwrEVKckufk8jjIh4
getPageData();

const getAreaList = async () => {
  const res = await request({
    url: "/api/wx/cs/list-group-detail",
    method: "POST",
    data: {
      startDay: time,
      endDay: time,
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
  });
  if (res.code === 200) {
    areaList.value = res.data;
  } else {
    // showFailToast(res.data);
  }
};
getAreaList();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, "生成时间： " + _toDisplayString(_unref(dayjs)(_unref(route).params.time as string).format("YYYY-MM-DD")), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(CellGroup), { style: {"background-color":"#fff"} }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageData.value, (item, index) => {
              return (_openBlock(), _createBlock(_unref(Cell), {
                title: item.name,
                size: index < 3 ? 'large' : 'normal',
                class: _normalizeClass('active'),
                "title-style": { width: '120px', flex: 'inherit' },
                border: index !== 3,
                key: index
              }, {
                value: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(item.type === "percentage"
                      ? _unref(formatPercentage)(item.value)
                      : item.value), 1)
                  ])
                ]),
                _: 2
              }, 1032, ["title", "size", "border"]))
            }), 128))
          ]),
          _: 1
        }),
        _hoisted_7,
        _hoisted_8,
        (!areaList.value.length)
          ? (_openBlock(), _createBlock(_unref(Empty), {
              key: 0,
              description: "暂无数据",
              "image-size": "100"
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(areaList.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("span", {
                      class: _normalizeClass({
                  one: index == 0,
                  two: index == 1,
                  three: index == 2,
                  other: index > 2,
                })
                    }, _toDisplayString(index + 1), 3),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(item.groupLeader), 1),
                    (item.groupLeader == '北京客服')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, "（北京客服的激活成功量暂未分配到各战斗小组）"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("table", _hoisted_15, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", _hoisted_16, [
                          _hoisted_17,
                          _createElementVNode("td", _hoisted_18, _toDisplayString(item.activeCount), 1)
                        ]),
                        (item.groupLeader !== '北京客服')
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                              _hoisted_20,
                              _createElementVNode("td", null, _toDisplayString(item.orderSuccessCount), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (item.groupLeader !== '北京客服')
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [
                              _hoisted_22,
                              _createElementVNode("td", null, _toDisplayString(item.orderCount), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _hoisted_23,
                    _createElementVNode("table", _hoisted_24, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", _hoisted_25, [
                          _hoisted_26,
                          _createElementVNode("td", _hoisted_27, _toDisplayString(item.monthActiveCount), 1)
                        ]),
                        (item.groupLeader !== '北京客服')
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_28, [
                              _hoisted_29,
                              _createElementVNode("td", null, _toDisplayString(item.monthOrderSuccessCount), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (item.groupLeader !== '北京客服')
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_30, [
                              _hoisted_31,
                              _createElementVNode("td", null, _toDisplayString(item.monthOrderCount), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ]))
      ])
    ], 512), [
      [_vShow, visible.value]
    ]),
    _createVNode(_unref(Overlay), {
      class: "overlay",
      show: !visible.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Loading), { type: "spinner" })
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})